export const snackBarReducer = (state, { type, payload }) => {
  state.isOpen = payload.visible;
  const snackBarType = payload && payload.type;

  return { ...state, ...payload, snackBarType, isOpen: payload.visible };
};
